import axios from "axios";
import config from "../config";

export default class ReferenceDataService {
  static getAllReferenceData() {
    return axios.get(`${config.baseUrl}/reference-data`);
  }
}
